
import AuthenticationDoc from './AuthenticationDoc';
import ExplorePageDoc from './ExplorePageDoc';
import PlacingOrdersDoc from './PlacingOrdersDoc';
import OrderManagementDoc from './OrderManagementDoc';
import DataDeliveryDoc from './DataDeliveryDoc';
import DocumentPage from './DocumentPage';
import DocumentationLayout from './DocumentationLayout';
import { BrowserRouter as Router, Route, Switch,  } from 'react-router-dom';
import TaskingImageryDoc from './TaskingImageryDoc';
import CatalogImageryDoc from './CatalogImageryDoc';

const DocumentationRoutes = () => {
  return (
    <DocumentationLayout>
      <Switch>
        {/* <Route path="/documentation/authentication" component={AuthenticationDoc}/> */}
        <Route path="/documentation/explore" component={ExplorePageDoc}/>
        <Route path="/documentation/placing-orders" component={PlacingOrdersDoc}/>
        <Route path="/documentation/order-management" component={OrderManagementDoc}/>
        <Route path="/documentation/data-delivery" component={DataDeliveryDoc}/>
        <Route path="/documentation/task-an-image" component={TaskingImageryDoc}/>
        <Route path="/documentation/catalog-imagery" component={CatalogImageryDoc}/>
        <Route exact path="/documentation" component={DocumentPage}/>

      </Switch>
    </DocumentationLayout>
  );
};

export default DocumentationRoutes;
